export const createRegExpFromString = (str: string): RegExp | null => {
  try {
    return new RegExp(str);
  } catch {
    console.error("no valid RegExp for ", str);
    return null;
  }
};
